import Button from "@/common/components/Button";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { formatDateTime } from "@/common/utils/formatters";
import { ArrowBigRightIcon, BriefcaseBusinessIcon, CarFrontIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { maintenanceForwardingsDirectiveEntryKlasses } from "../constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { maintenanceWorkflowStatus } from "../constants/maintenanceWorkflowsStatus.constant";
import { MaintenaceWorkflowData } from "../types/maintenanceWorkflows.type";

export class MaintenanceWorkflowsTransformer {

  static tableTransformer() {
    return (workflows: MaintenaceWorkflowData[]) => {
      return workflows.map((workflow) => {
        const directiveEntryData = workflow.current_forwarding && maintenanceForwardingsDirectiveEntryKlasses[workflow.current_forwarding.directive_entry_type];

        return {
          status: maintenanceWorkflowStatus[workflow.status] || workflow.status,
          current_forwarding: workflow.current_forwarding && (
            <div className="flex flex-col">
              <p>
                {directiveEntryData?.label || '--'}
              </p>

              {workflow.current_forwarding.translated_status_of_ongoing_entry && (
                <p className="text-xs italic">
                  {workflow.current_forwarding.translated_status_of_ongoing_entry}
                </p>
              )}
            </div>
          ),
          protocol_number: (
            <div className="flex flex-col">
              <p>
                {workflow.protocol_number}
              </p>

              <p className="text-xs italic text-white-400">
                {formatDateTime(new Date(workflow.created_at))}
              </p>
            </div>
          ),
          company: (
            <ImageWithDisplayName
              placeholderIcon={BriefcaseBusinessIcon}
              imageUrl={workflow.company?.general_information?.company_logo?.url}
              displayName={workflow.company?.general_information?.fantasy_name}
            />
          ),
          equipment: (
            <ImageWithDisplayName
              placeholderIcon={CarFrontIcon}
              imageUrl={workflow.equipment?.photos?.[0]?.url}
              displayName={workflow.equipment?.field_for_display_value}
            />
          ),
          actions: (
            <Link to={workflow.id}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Establishment::Maintenance::Workflows::Show"
              >
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        };
      });
    }
  }

}
